import type { Router } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

/** 是否已在本次页面加载中执行过服务端用户刷新 */
let userRefreshed = false

export function setupRouterGuards(router: Router) {
  // 全局前置守卫
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    
    // 初始化认证状态（确保 localStorage 中的 Token 已加载到 store）
    authStore.initializeAuth()

    // 每次页面加载后首次导航时，从服务端刷新用户信息（确保 role 等字段是最新的）
    if (!userRefreshed && authStore.isLoggedIn) {
      userRefreshed = true
      void authStore.refreshUserFromServer()
    }
    
    // 使用 isLoggedIn 检查登录状态（兼容 store 未初始化时的 localStorage 降级检查）
    const loggedIn = authStore.isLoggedIn
    
    // 检查路由是否需要认证（默认受保护，除非显式设置 requiresAuth: false）
    const requiresAuth = to.meta.requiresAuth !== false
    
    if (requiresAuth && !loggedIn) {
      // 需要认证但未登录，重定向到登录页（需求 9.10）
      next('/login')
    } else if (to.meta.requiresAdmin && !authStore.isAdmin) {
      // 需要管理员权限但当前用户不是管理员，静默重定向到首页
      next('/dashboard')
    } else if (to.path === '/login' && loggedIn) {
      // 已登录用户访问登录页，自动重定向到首页（需求 9.9）
      next('/dashboard')
    } else {
      next()
    }
  })
  
  // 全局后置钩子
  router.afterEach((to) => {
    // 设置页面标题
    const title = to.meta.title as string
    if (title) {
      document.title = `${title} - 资产管家`
    }
  })
}